import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import gamblerGame from "./gamblerGame";
import gamblerGameObj from "./gamblerGameObj";

const {ccclass, property} = cc._decorator;

@ccclass
export default class gamblerExplain extends cc.Component {

    @property({type:cc.Node,displayName:"light"})
    lightNode:cc.Node = null;

    @property({type:cc.Label,displayName:"描述文本"})
    lbExplain:cc.Label = null;

    @property({type:cc.Label,displayName:"重量文本"})
    lb_weight:cc.Label = null;

    @property({type:cc.Label,displayName:"价格文本"})
    lb_price:cc.Label = null;

    start(){
        let tween = cc.tween(this.lightNode).by(3,{angle:360}).call(()=>{
            this.lightNode.angle = 0;
        });
        cc.tween(this.lightNode).repeatForever(tween).start();
    }

    gameScript:gamblerGame = null;

    buyNode:cc.Node = null;

    buyScript:gamblerGameObj = null;

    bindData(node:cc.Node,gameScript:gamblerGame){
        this.buyNode = node;
        this.buyScript = this.buyNode.getComponent(gamblerGameObj);
        this.gameScript = gameScript;
        this.updatePage();
    }

    updatePage(){
        this.lbExplain.string = this.buyScript.startData.explain;
        this.lb_price.string = data_control.getNumberFormat(this.buyScript.startData.price);
        this.lb_weight.string = this.buyScript.startData.weight + "kg";
    }

    onBtnBuy(){
        this.gameScript.startCutObj(this.buyNode);
        this.node.destroy();
        this.node.removeFromParent();
    }

    onBtnClose(){
        this.node.destroy();
        this.node.removeFromParent();
    }

    
}